
    import Ember from 'ember';
    import "coffeescripts/ember/shared/helpers/common";
import "i18n!screenreader_gradebook.components.final_grade_override";

    Ember.TEMPLATES['components/final-grade-override'] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("<div id=\"final-grade-override\">\n  <label for=\"final-grade-override-input\">\n    <strong>");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "final_grade_override_be8a21cd", "Final Grade Override", options) : helperMissing.call(depth0, "t", "final_grade_override_be8a21cd", "Final Grade Override", options))));
  data.buffer.push("</strong>\n  </label>\n  ");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'id': ("final-grade-override-input"),
    'type': ("text"),
    'value': ("inputValue")
  },hashTypes:{'id': "STRING",'type': "STRING",'value': "ID"},hashContexts:{'id': depth0,'type': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("\n\n  ");
  stack1 = helpers._triageMustache.call(depth0, "inputDescription", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n</div>\n");
  return buffer;
  
});
  